import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAuthSession } from '../../redux/action/auth';
import InitialLoading from './InitialLoading';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, loading } = useSelector(state => state.auth);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        await dispatch(checkAuthSession());
      } catch (error) {
        console.error('Auth check failed:', error);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    verifyAuth();
  }, [dispatch]);

  // Show loading while checking authentication
  if (isCheckingAuth || loading) {
    return <InitialLoading />;
  }

  // If not authenticated, redirect to home page (or login page)
  if (!isAuthenticated) {
    // Save the attempted URL to redirect back after login
    sessionStorage.setItem('redirectAfterLogin', location.pathname);
    return <Navigate to="/" replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
